module.exports = __webpack_public_path__ + "static/img/emoji_146.7d2515c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji/emoji_146.png
// module id = frTK
// module chunks = 6